export const TrackStatus = {
    DRAFT: 'Draft',
    PUBLISHED: 'Published'
}

export const ChapterState = {
    PASSED: 0,
    SELECTED: 1,
    UPCOMING: 2
}

export const SparkState = {
    PENDING: 0,
    COMPLETED: 1
}

export const MeetingType = {
    IN_PERSON: 'InPerson',
    VIRTUAL: 'Virtual'
}

export const QuestionType = {
    STATIC: 'Static',
    DYNAMIC: 'Dynamic'
}

export const AnswerType = {
    SINGLE: 'SingleAnswer',
    MULTI: 'MultiAnswer',
    TEXT: 'Text'
}

export const QuestionSelector = {
    TRACKS: 'ProgramTracks'
}

export const QuestionSymmetry = {
    MENTOR: 'Mentor',
    MENTEE: 'Mentee',
    BOTH: 'Both'
}

export const ParticipantType = {
    MENTOR: 'Mentor',
    MENTEE: 'Mentee'
}

export const MatchingState = {
    WAITING: 'WaitingForMatch',
    PREVIEW: 'Preview',
    PROPOSED: 'MatchProposed',
    AGREEMENT: 'Agreement',
    CONFIRMED: 'MatchConfirmed'
}
